import styled from 'styled-components';
import Screen from 'src/styles/Themes/Screen';

export const ShopperApprovedClear = () => {
    return (
        <>
            <Wrapper
                href="https://www.shopperapproved.com/reviews/TripShock.com"
                className="shopperlink"
                target="_blank"
            >
                <img
                    width="178"
                    height="91"
                    src="/image/ShopperApproved.svg"
                    alt="5 Star Excellence award from Shopper Approved for collecting at least 100 5 star reviews"
                    onContextMenu={() => {
                        const d = new Date();
                        alert(
                            'Copying Prohibited by Law - This image and all included logos are copyrighted by Shopper Approved \xa9 ' +
                                d.getFullYear() +
                                '.'
                        );
                        return false;
                    }}
                />
            </Wrapper>
        </>
    );
};

const Wrapper = styled.a`
    height: 45px;

    margin-top: 30px;

    ${Screen.desktop} {
        margin: 0;
    }

    img {
        height: 45px;
        width: 88px;
    }
`;
